/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Follow_People_FollowsInputs */

const en_follow_people_follows = /** @type {(inputs: Follow_People_FollowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`People ${i?.name} follows`)
};

const es_follow_people_follows = /** @type {(inputs: Follow_People_FollowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Personas a las que sigue ${i?.name}`)
};

const fr_follow_people_follows = /** @type {(inputs: Follow_People_FollowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Personnes que ${i?.name} suit`)
};

const de_follow_people_follows = /** @type {(inputs: Follow_People_FollowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Personen, denen ${i?.name} folgt`)
};

const id_follow_people_follows = /** @type {(inputs: Follow_People_FollowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Orang yang ${i?.name} ikuti`)
};

/** @type {(inputs: Follow_People_FollowsInputs) => LocalizedString} */
const ja_follow_people_follows = en_follow_people_follows;

/** @type {(inputs: Follow_People_FollowsInputs) => LocalizedString} */
const zh_follow_people_follows = en_follow_people_follows;

/** @type {(inputs: Follow_People_FollowsInputs) => LocalizedString} */
const ar_follow_people_follows = en_follow_people_follows;

/** @type {(inputs: Follow_People_FollowsInputs) => LocalizedString} */
const it_follow_people_follows = en_follow_people_follows;

/** @type {(inputs: Follow_People_FollowsInputs) => LocalizedString} */
const ru_follow_people_follows = en_follow_people_follows;

/** @type {(inputs: Follow_People_FollowsInputs) => LocalizedString} */
const pt_follow_people_follows = en_follow_people_follows;

/** @type {(inputs: Follow_People_FollowsInputs) => LocalizedString} */
const ko_follow_people_follows = en_follow_people_follows;

/**
* | output |
* | --- |
* | "People {name} follows" |
*
* @param {Follow_People_FollowsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_people_follows = /** @type {((inputs: Follow_People_FollowsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_People_FollowsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_people_follows(inputs)
	if (locale === "es") return es_follow_people_follows(inputs)
	if (locale === "fr") return fr_follow_people_follows(inputs)
	if (locale === "de") return de_follow_people_follows(inputs)
	if (locale === "ja") return ja_follow_people_follows(inputs)
	if (locale === "zh") return zh_follow_people_follows(inputs)
	if (locale === "ar") return ar_follow_people_follows(inputs)
	if (locale === "id") return id_follow_people_follows(inputs)
	if (locale === "it") return it_follow_people_follows(inputs)
	if (locale === "ru") return ru_follow_people_follows(inputs)
	if (locale === "pt") return pt_follow_people_follows(inputs)
	return ko_follow_people_follows(inputs)
});